import type { ColDef, GetRowIdParams, GridOptions, ValueFormatterParams } from 'ag-grid-community';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseDetailItem } from '~/types/stock.types';

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 상세 > 반출 요청 상품 테이블
 */
const getStockReleaseDetailItemsColumnDefs = () => {
  const gridOptions: GridOptions = {
    getRowId: (params: GetRowIdParams<TypeStockReleaseDetailItem>) => String(params.data.skuCode),
  };

  const columnDefs: ColDef<TypeStockReleaseDetailItem>[] = [
    {
      headerName: 'No',
      valueGetter: 'node.rowIndex + 1',
      width: 72,
    },
    {
      field: 'skuCode',
      headerName: 'SKU코드',
      width: 140,
    },
    {
      field: 'barcode',
      headerName: '상품 바코드',
      width: 140,
    },
    {
      field: 'skuName',
      headerName: '상품명',
      width: 240,
    },
    {
      field: 'temperatureTypeCodeObject.name',
      headerName: '보관 유형',
      width: 76,
    },
    {
      field: 'availableRequestQuantity',
      headerName: '반출 요청 수량 (가용)',
      width: 142,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseDetailItem, TypeStockReleaseDetailItem['availableRequestQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'defectiveRequestQuantity',
      headerName: '반출 요청 수량 (불용)',
      width: 142,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseDetailItem, TypeStockReleaseDetailItem['defectiveRequestQuantity']>) =>
        formatNumber(value ?? 0),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'availableActualQuantity',
      headerName: '반출 완료 수량 (가용)',
      width: 142,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseDetailItem, TypeStockReleaseDetailItem['availableActualQuantity']>) => {
        if (typeof value === 'number' && !isNaN(Number(value))) {
          return formatNumber(value);
        } else {
          return value ? String(value) : '-';
        }
      },
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'defectiveActualQuantity',
      headerName: '반출 완료 수량 (불용)',
      width: 142,
      valueFormatter: ({
        value,
      }: ValueFormatterParams<TypeStockReleaseDetailItem, TypeStockReleaseDetailItem['defectiveActualQuantity']>) => {
        if (typeof value === 'number' && !isNaN(Number(value))) {
          return formatNumber(value);
        } else {
          return value ? String(value) : '-';
        }
      },
      cellStyle: { textAlign: 'right' },
    },
  ];

  return { gridOptions, columnDefs };
};

export default getStockReleaseDetailItemsColumnDefs;
